const Utils = {}

Utils.blues = [
  {
    color: '#dde9f0',
    textColor: 'black',
    state: 'Lean D',
    lower: 25,
    upper: 40,
    width: 15
  },
  {
    color: '#a5c9df',
    textColor: 'black',
    state: 'Likely D',
    lower: 10,
    upper: 25,
    width: 15
  },
  {
    color: '#66abcf',
    textColor: 'white',
    state: 'Safe D',
    lower: 0,
    upper: 10,
    width: 10
  }
]
Utils.tossup = [
  {
    color: '#854C79',
    textColor: 'white',
    state: 'Toss Up',
    lower: 40,
    upper: 60,
    width: 20
  }
]
Utils.reds = [
  {
    color: '#ffbeb7',
    textColor: 'black',
    state: 'Lean R',
    lower: 60,
    upper: 75,
    width: 15
  },
  {
    color: '#ff998e',
    textColor: 'black',
    state: 'Likely R',
    lower: 75,
    upper: 90,
    width: 15
  },
  {
    color: '#FA3138',
    textColor: 'white',
    state: 'Safe R',
    lower: 90,
    upper: 100,
    width: 10
  }
]

Utils.dFlip = {
  color: '#66ABCF',
  fromColor: '#FA3138',
  text: 'Potential R ➔ D Flip',
  gradient: 'linear-gradient(45deg, #FA3138 0%, #FA3138 50%, #66ABCF 50%, #66ABCF 100%)',
  value: 1
}

Utils.rFlip = {
  color: '#FA3138',
  fromColor: '#66ABCF',
  text: 'Potential D ➔ R Flip',
  gradient: 'linear-gradient(45deg, #66ABCF 0%, #66ABCF 50%, #FA3138 50%, #FA3138 100%)',
  value: -1
}

Utils.colorScale = [...Utils.blues.reverse(), ...Utils.tossup, ...Utils.reds]

Utils.getColorScale = (value) => {
  let colorObject = null
  Utils.colorScale.forEach(obj => {
    if (value >= obj.lower && value <= obj.upper) {
      colorObject = obj
    }
  })
  return colorObject
}

Utils.getFlip = (value) => {
  if (value === 1) {
    return Utils.dFlip
  } else if (value === -1) {
    return Utils.rFlip
  }
}

export default Utils



// WEBPACK FOOTER //
// ./src/utils.js